export const HEADER_DARK_READ = "X-FAIRE-PERF-DARK";
export const HEADER_DARK_READ_ORIGINAL_REQUEST = "X-FAIRE-PERF-DARK-ORIGINAL";
